export default __webpack_public_path__ + "images/ab1aea90a68722475e80ce741f55078b-spirits.jpg";